import { useEffect } from 'react'
import { Outlet } from 'react-router'

import i18n from '@app/i18n'

import { CartManager } from '@entities/Cart'
import { DeliveryManager } from '@entities/DeliveryZone'

import { AuthProvider } from '@features/auth'
import { useCartSyncStorage } from '@features/cart'
import { useModalStore } from '@features/modal'
import ModalRoot from '@features/modal/ui'
import { Overlay } from '@features/overlay'

import { CookieConsent } from '@widgets/cookie-consent/CookieConsent'
import { Footer } from '@widgets/footer'
import { Header } from '@widgets/header'
import { useHeaderStore } from '@widgets/header/model/headerStore'
import MinimalHeader from '@widgets/header/ui/MinimalHeader'

import { client } from '@shared/api/client'
import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'
import ScrollToTop from '@shared/ui/scroll-top'
import { ToastContainer } from '@shared/ui/toast/ToastContainer'

import 'react-loading-skeleton/dist/skeleton.css'

export default function RootLayout () {
  const { closeModal } = useModalStore()
  const navigate = useNavigate()
  const { variant } = useHeaderStore()

  useEffect(() => {
    closeModal('mobileMenu')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ navigate ])

  // Синхронизация корзины с localStorage
  useCartSyncStorage()

  useEffect(() => {
    const handleLanguageChange = () => {
      client.resetStore()
    }

    i18n.on('languageChanged', handleLanguageChange)
    return () => {
      i18n.off('languageChanged', handleLanguageChange)
    }
  }, [])

  return (
    <>
      <ScrollToTop />
      <AuthProvider>
        {/* Изолированный менеджер корзины — ререндерится отдельно от layout */}
        <CartManager />
        {/* Изолированный менеджер доставки — все запросы тут, остальные читают из store */}
        <DeliveryManager />
        <div className="site">
          <div className="site-top">
            {variant === 'minimal' ? <MinimalHeader /> : <Header />}
            <Outlet />
            <ModalRoot />
          </div>
          <div className="site-bottom">
            <Footer />
          </div>
        </div>
        <ToastContainer />
        <Overlay />
        <CookieConsent />
      </AuthProvider>
    </>
  )
}
